import { render, staticRenderFns } from "./ContentCreatorBundleView.vue?vue&type=template&id=f06f4304&scoped=true&"
import script from "./ContentCreatorBundleView.vue?vue&type=script&lang=ts&"
export * from "./ContentCreatorBundleView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCreatorBundleView.vue?vue&type=style&index=0&id=f06f4304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f4304",
  null
  
)

export default component.exports